import { useEffect, useRef } from 'react'
import consumer from '@/channels/consumer'

interface RawEntryData {
  sequence: number
  entry_type: string
  data: Record<string, unknown>
}

interface ChannelMessage {
  type: 'new_entry' | 'session_finished'
  entry?: RawEntryData
  status?: string
}

export function useSessionLogChannel(
  sessionLogId: number,
  isStreaming: boolean,
  onEntry: (entry: RawEntryData) => void,
  onFinished: (status: string) => void
) {
  const onEntryRef = useRef(onEntry)
  const onFinishedRef = useRef(onFinished)
  onEntryRef.current = onEntry
  onFinishedRef.current = onFinished

  useEffect(() => {
    if (!isStreaming) return

    const subscription = consumer.subscriptions.create(
      { channel: 'Agents::SessionLogChannel', session_log_id: sessionLogId },
      {
        received(message: ChannelMessage) {
          if (message.type === 'new_entry' && message.entry) {
            onEntryRef.current(message.entry)
          } else if (message.type === 'session_finished') {
            onFinishedRef.current(message.status ?? 'completed')
          }
        },
      }
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [sessionLogId, isStreaming])
}
